
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Слой_2","data-name":"Слой 2","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 865 901"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"cls-1",attrs:{"d":"M5 536h126v360H5z"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M194 320h126v576H194zM374 455h126v441H374z"}}),_c('path',{attrs:{"stroke":"#89898a","stroke-linejoin":"round","fill":"#898a8a","stroke-width":"10","d":"M554 176h126v720H554z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M734 392h126v504H734z"}}),_c('path',{attrs:{"d":"M68 392l189-216 171 153L608 32l180 216","fill":"none","stroke-linecap":"round","stroke-width":"25","stroke":"#898a8a","stroke-linejoin":"round"}}),_c('circle',{staticClass:"cls-2",attrs:{"cx":"68","cy":"392","r":"27"}}),_c('circle',{staticClass:"cls-2",attrs:{"cx":"428","cy":"320","r":"27"}}),_c('circle',{staticClass:"cls-2",attrs:{"cx":"788","cy":"248","r":"27"}}),_c('circle',{staticClass:"cls-2",attrs:{"cx":"257","cy":"176","r":"27"}}),_c('circle',{staticClass:"cls-2",attrs:{"cx":"608","cy":"32","r":"27"}})])
          )
        }
      }
    